import React from 'react';

import { Link } from 'react-router-dom';
import { DropzoneArea } from 'material-ui-dropzone';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import StarIcon from '@mui/icons-material/Star';
import { Image, Row, Col, Container } from 'react-bootstrap';

import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useDropzone } from 'react-dropzone';
import Sidebar from '../../../common/Sidebar/Sidebar';

import {
  AddBannerMedia,
  UpdateCarAgentListing,
  getCarAgentListing,
  deleteMediaBanner,
  deleteMediaBannerBatch,
  reorderBannerMedia,
} from './../../../../Redux/Actions/UserAction';
import { CarAgentCommonHeader } from './CarAgentCommonHeader';

const CarDealersBanner = () => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  const home = useSelector((state) => state?.home);
  const CarDealertList = home?.CarDealertList;

  const dispatch = useDispatch();

  // Always fetch car agent data on mount
  useEffect(() => {
    dispatch(getCarAgentListing(sessionStorage.getItem('BusinessId')));
  }, []);


  const mediaId = home?.AddMediaList?.data?.response?.media;

  // Main Banner state
  const [mainBannerFiles, setMainBannerFiles] = useState();
  const [mainBannerReady, setMainBannerReady] = useState(false);

  // Gallery Banner state
  const [galleryFiles, setGalleryFiles] = useState();
  const [galleryReady, setGalleryReady] = useState(false);

  // Track which upload triggered the media response
  const uploadTypeRef = useRef('BANNER');
  // Only TRUE after an upload from THIS page — guards the stale-logo-as-banner bug.
  const pendingUploadRef = useRef(false);

  const handleMainBannerUpload = (file) => {
    if (file && file.length > 0) {
      setMainBannerFiles(file);
      setMainBannerReady(true);
    } else {
      setMainBannerReady(false);
    }
  };

  const handleGalleryUpload = (file) => {
    if (file && file.length > 0) {
      setGalleryFiles(file);
      setGalleryReady(true);
    } else {
      setGalleryReady(false);
    }
  };

  const submitMainBanner = () => {
    const formData = new FormData();
    if (mainBannerFiles && mainBannerFiles.length > 0) {
      mainBannerFiles.map((item) => formData.append('media', item));
      uploadTypeRef.current = 'MAIN_BANNER';
      pendingUploadRef.current = true;
      dispatch(AddBannerMedia({ formData }));
    }
  };

  const submitGalleryBanners = () => {
    const formData = new FormData();
    if (galleryFiles && galleryFiles.length > 0) {
      galleryFiles.map((item) => formData.append('media', item));
      uploadTypeRef.current = 'BANNER';
      pendingUploadRef.current = true;
      dispatch(AddBannerMedia({ formData }));
    }
  };

  useEffect(() => {
    if (!pendingUploadRef.current) return;
    if (mediaId !== undefined) {
      var BannerId = mediaId?.map((item) => item.mediaId);
    }

    if (BannerId && BannerId.length > 0) {
      pendingUploadRef.current = false;
      const mediaIds = {};
      if (uploadTypeRef.current === 'MAIN_BANNER') {
        mediaIds.MAIN_BANNER = BannerId;
      } else {
        mediaIds.BANNER = BannerId;
      }
      dispatch(UpdateCarAgentListing({ mediaIds }));
      // Refresh banners once the update is saved.
      setTimeout(() => dispatch(getCarAgentListing(sessionStorage.getItem('BusinessId'))), 800);
      setMainBannerReady(false);
      setGalleryReady(false);
    }
  }, [mediaId]);

  const DeleteBanner = (businessMediaId) => {
    dispatch(deleteMediaBanner(businessMediaId));
  };

  const mainBanner = CarDealertList?.businessMedia?.find(
    (item) => item?.mediaType === 'MAIN_BANNER'
  );

  // ===== Gallery reorder + multi-select delete =====
  const galleryBanners = (CarDealertList?.businessMedia || [])
    .filter((item) => item?.mediaType === 'BANNER')
    .sort((a, b) => {
      // Reflect the saved order by sorting on priority (ascending).
      const pa = a?.priority ?? Number.MAX_SAFE_INTEGER;
      const pb = b?.priority ?? Number.MAX_SAFE_INTEGER;
      return pa - pb;
    });
  const [galleryOrder, setGalleryOrder] = useState([]); // local display order of businessMediaIds
  const [selectedBanners, setSelectedBanners] = useState([]); // checked for delete
  const dragBannerId = useRef(null);

  // Keep local order in sync with fetched gallery banners (append new, drop removed).
  useEffect(() => {
    const ids = galleryBanners.map((b) => b?.businessMediaId);
    setGalleryOrder((prev) => {
      const kept = prev.filter((id) => ids.includes(id));
      const added = ids.filter((id) => !kept.includes(id));
      return [...kept, ...added];
    });
    setSelectedBanners((prev) => prev.filter((id) => ids.includes(id)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [CarDealertList]);

  const orderedGallery = galleryOrder
    .map((id) => galleryBanners.find((b) => b?.businessMediaId === id))
    .filter(Boolean);

  const onBannerDragStart = (id) => (dragBannerId.current = id);
  const onBannerDragOver = (e) => e.preventDefault();
  const onBannerDrop = (targetId) => {
    const src = dragBannerId.current;
    dragBannerId.current = null;
    if (!src || src === targetId) return;
    setGalleryOrder((prev) => {
      const next = [...prev];
      const from = next.indexOf(src);
      const to = next.indexOf(targetId);
      if (from < 0 || to < 0) return prev;
      next.splice(from, 1);
      next.splice(to, 0, src);
      // Persist the new banner order to the backend (main banner kept first).
      const ids = mainBanner?.businessMediaId
        ? [mainBanner.businessMediaId, ...next]
        : next;
      dispatch(reorderBannerMedia(ids));
      return next;
    });
  };

  const toggleSelectBanner = (id) =>
    setSelectedBanners((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );

  const deleteSelectedBanners = () => {
    // [FB2-#4] Delete ALL selected banners in one batch (one confirm, one
    // refresh). The old per-item loop fired a Swal+reload per id, so only the
    // first selected banner was ever removed.
    dispatch(
      deleteMediaBannerBatch(selectedBanners, () => {
        setSelectedBanners([]);
        setTimeout(
          () => dispatch(getCarAgentListing(sessionStorage.getItem('BusinessId'))),
          300
        );
      })
    );
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-cars-agents-business',
      label: 'Manage Business',
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-cars-agents-cars',
      label: 'Manage Service',
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-cars-agents-banner',
      label: 'Banner',
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-car-dealers-working-hours',
      label: 'Manage Working Hours',
    },
  ];

  return (
    <div>
      <CarAgentCommonHeader />

      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h2 class="mb-4">Manage Banner</h2>

              {/* ===== SECTION 1: MAIN BANNER ===== */}
              <div style={{ background: '#fff9ed', border: '2px solid #f5a623', borderRadius: '10px', padding: '1.5rem', marginBottom: '2rem' }}>
                <h4 style={{ marginBottom: '0.5rem' }}>
                  <StarIcon style={{ color: '#f5a623', marginRight: '5px', verticalAlign: 'middle' }} />
                  Main Banner
                </h4>
                <p style={{ color: '#666', fontSize: '0.85rem', marginBottom: '1rem' }}>
                  This banner is displayed prominently at the top of your business page. Only one main banner allowed.
                </p>

                {/* Current Main Banner */}
                {mainBanner ? (
                  <div style={{ marginBottom: '1rem' }}>
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                      <DeleteForeverIcon
                        style={{ cursor: 'pointer', position: 'absolute', top: 5, right: 5, color: '#dc3545', zIndex: 1, background: '#fff', borderRadius: '50%', padding: '2px' }}
                        onClick={() => DeleteBanner(mainBanner?.businessMediaId)}
                      />
                      <Image
                        style={{ width: '100%', maxWidth: '500px', maxHeight: '200px', objectFit: 'cover', border: '3px solid #f5a623', borderRadius: '8px' }}
                        src={mainBanner?.media?.path}
                        rounded
                      />
                    </div>
                  </div>
                ) : (
                  <p style={{ color: '#999', fontStyle: 'italic', marginBottom: '1rem' }}>
                    No main banner uploaded yet.
                  </p>
                )}

                {/* Main Banner Upload */}
                <DropzoneArea
                  acceptedFiles={['image/*']}
                  dropzoneText={'Upload Main Banner (1 image)'}
                  filesLimit={1}
                  showPreviews={true}
                  showPreviewsInDropzone={false}
                  onChange={(files) => handleMainBannerUpload(files)}
                />
                <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                  <button
                    class="btn btn-warning"
                    onClick={submitMainBanner}
                    disabled={!mainBannerReady}
                    style={{ minWidth: '200px' }}
                  >
                    Save Main Banner
                  </button>
                </div>
              </div>

              {/* ===== SECTION 2: GALLERY BANNERS ===== */}
              <div style={{ background: '#f9f9f9', border: '2px solid #ddd', borderRadius: '10px', padding: '1.5rem' }}>
                <h4 style={{ marginBottom: '0.5rem' }}>
                  Gallery Banners
                </h4>
                <p style={{ color: '#666', fontSize: '0.85rem', marginBottom: '1rem' }}>
                  Additional banners displayed in your business gallery. You can upload multiple images.
                </p>

                {/* Multi-select delete toolbar */}
                {selectedBanners.length > 0 && (
                  <div style={{ marginBottom: '0.75rem' }}>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={deleteSelectedBanners}
                    >
                      Delete selected ({selectedBanners.length})
                    </button>
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => setSelectedBanners([])}
                    >
                      Clear selection
                    </button>
                  </div>
                )}

                {/* Current Gallery Banners (drag to reorder, checkbox to multi-delete) */}
                <Container>
                  <Row>
                    {orderedGallery.map((item) => {
                      const id = item?.businessMediaId;
                      const isChecked = selectedBanners.includes(id);
                      return (
                        <Col
                          xs={6}
                          md={3}
                          key={id}
                          style={{ marginBottom: '1rem' }}
                          draggable
                          onDragStart={() => onBannerDragStart(id)}
                          onDragOver={onBannerDragOver}
                          onDrop={() => onBannerDrop(id)}
                        >
                          <div style={{ position: 'relative', cursor: 'move' }}>
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={() => toggleSelectBanner(id)}
                              style={{ position: 'absolute', top: 4, left: 5, zIndex: 2, width: 18, height: 18 }}
                            />
                            <DeleteForeverIcon
                              style={{ cursor: 'pointer', position: 'absolute', top: 0, right: 5, color: '#dc3545', zIndex: 1, background: '#fff', borderRadius: '50%', padding: '2px' }}
                              onClick={() => DeleteBanner(id)}
                            />
                            <Image
                              style={{ width: '100%', height: '6rem', objectFit: 'cover', borderRadius: '6px' }}
                              src={item?.media?.path}
                              rounded
                            />
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </Container>

                {/* Gallery Upload */}
                <DropzoneArea
                  acceptedFiles={['image/*']}
                  dropzoneText={'Upload Gallery Banners (up to 10 images)'}
                  filesLimit={10}
                  showPreviews={true}
                  showPreviewsInDropzone={false}
                  onChange={(files) => handleGalleryUpload(files)}
                />
                <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                  <button
                    class="btn btn-warning"
                    onClick={submitGalleryBanners}
                    disabled={!galleryReady}
                    style={{ minWidth: '200px' }}
                  >
                    Save Gallery Banners
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarDealersBanner;
